module.exports = __webpack_public_path__ + "static/media/logo_vietinbank.a74313b1.svg";